import { useAppConstantsContext } from '@/context/AppConstants';
import { Link, Text, styled } from '@/theme/index';

const ComplianceFooterContent = styled('div')(({ theme }) => ({
  width: '100%',
  lineHeight: 1.4,
  marginTop: theme.spacing(1.5),
  color: theme.palette.secondary.contrastText,
}));

export function ComplianceFooterLabel() {
  const {
    data: { brandName, complianceEmail },
    links: { doDontsLink },
  } = useAppConstantsContext();

  return (
    <ComplianceFooterContent>
      <Text variant="h6" fontWeight={300}>
        If you are still unsure whether your use of {brandName} is appropriate,
        we encourage you to review our{' '}
        <Link
          href={doDontsLink}
          target="_blank"
          underline="always"
          color="success.main"
        >
          <strong>Do's and Don'ts</strong>
        </Link>{' '}
        page or contact us at{' '}
        <Link
          href={`mailto:${complianceEmail}`}
          underline="always"
          color="success.main"
        >
          <strong>{complianceEmail}</strong>
        </Link>
      </Text>
    </ComplianceFooterContent>
  );
}
